(function () {
    'use strict';

    angular
        .module('sodDocumentLibrary')
        .directive('sodDocumentLibrary', sodDocumentLibrary);

    function sodDocumentLibrary() {
        return {
            restrict: 'E',
            controller: sodDocumentLibraryCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                selected: '=?',
                getModel: '=?',
                useDocumentTrigger: '&?',
                close: '=?',
            },
            templateUrl: 'common/libraries/document-library/document-library'
        };
    }

    function sodDocumentLibraryCtrl(DocumentService, lodash, $scope, $timeout, $element, $filter) {
        const vm = this;
        this.$onInit = function() {
            vm.dlNotifications = [];
            vm.crumbs = [];

            prepareUploadOptions();

            vm.useDocuments = useDocuments;
            vm.toggleSelect = toggleSelect;
            vm.isItemSelected = isItemSelected;
            vm.handleRemoveDocument = handleRemoveDocument;
            vm.getModel = getModel;
            vm.dismiss = dismiss;
            vm.removeDlNotification = removeDlNotification;
            vm.applySearch = applySearch;
            vm.changeFolder = changeFolder;

            vm.documentService = new DocumentService(vm.options);
            init();

            vm.selectData = {
                selected: (!!vm.selected) ? vm.selected : [],
                selectAllFlag: false,
                filter: [],
                isMassSelectedItems: true,
                nextStep: false
            };
        }

        function init() {
            const dsOptions = lodash.get(vm.options, 'datasources.query', null);
            if (dsOptions === null) return;
            vm.folderId = lodash.get(vm.options, 'initialFolderId', null);

            if (lodash.has(dsOptions, 'data')) {
                vm.dataSource = new kendo.data.DataSource({
                    data: dsOptions.data,
                    pageSize: 10
                });
            }
            if (!lodash.has(dsOptions, 'data')) {
                vm.dataSource = new kendo.data.DataSource({
                    transport: {
                        read: getDocuments
                    },
                    schema: {
                        data: 'rows',
                        total: 'count'
                    },
                    serverPaging: true,
                    pageSize: 20,
                });
            }
            vm.options.list.dataSource = vm.dataSource;
            vm.options.list.dataBound = listDataBound;
        }

        function listDataBound() {
            if (vm.dataSource.data().length === 0) {
                $element.find('.k-listview').html(lodash.get(vm.options, 'list.noRecords', '<h4>No Records</h4>'));
            }
        }

        function prepareUploadOptions() {
            if (!lodash.has(vm.options, 'upload.sync.saveurl') && lodash.has(vm.options, 'datasources.store')) {
                const storeDs = lodash.get(vm.options, 'datasources.store', {});
                lodash.set(vm.options, 'upload.async.saveVerb', 'POST');
                lodash.set(vm.options, 'upload.async.saveUrl', lodash.get(storeDs, 'route', ''));

                lodash.set(vm.options, 'upload.upload', handleUploadStart);
                lodash.set(vm.options, 'upload.success', handleUploadSuccess);
                lodash.set(vm.options, 'upload.progress', handleUploadProgress);
                lodash.set(vm.options, 'upload.error', handleUploadError);
                lodash.set(vm.options, 'upload.complete', handleUploadComplete);
            }
        }

        function getDocuments(readOptions) {
            // prepare filters for folder
            vm.documentService.query(readOptions.data, vm.searchText, vm.folderId || 'top').then(function(res) {
                vm.crumbs = lodash.get(res, 'crumbs', []);
                readOptions.success(res);
            }, function(err) {
                readOptions.error(err);
            })
        }

        function applySearch() {
            vm.options.list.dataSource.read(); 
        }

        function getModel() {
            return vm.selectData.selected;
        }

        function handleRemoveDocument(dataItem) {
            const removeNotification = {
                template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.removing', 'Removing...'), dataItem),
                id: dataItem.select_id,
            };
            vm.dlNotifications.push(removeNotification);
            vm.documentService.remove(dataItem.id).then(function() {
                removeDlNotification(removeNotification);
                addNotificationWithTimeout({
                    template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.removed', 'Removed...'), dataItem),
                    id: dataItem.select_id,
                });
                const index = lodash.findIndex(vm.selectData.selected, { select_id: dataItem.select_id});
                if (index >= 0) {
                    vm.selectData.selected.splice(index, 1);
                }
                vm.dataSource.read();
            }, function (err) {
                // show notification
                removeDlNotification(removeNotification);
                addNotificationWithTimeout({
                    template: 'Removed Error',
                    id: dataItem.select_id,
                });
                vm.dataSource.read();
            });
        }

        function updateDocuments() {

        }

        function useDocuments() {
            vm.loading = true;
            // trigger an event and sending the selectedData over.
            if (lodash.has(vm.options, 'trigger.use')) {
                $scope.$emit(vm.options.trigger.use);
            } else {
                vm.useDocumentTrigger();
            }
        }

        function createFolder() {

        }

        function deleteFolder() {

        }

        function handleSelection() {

        }

        function handleUploadStart(e) {
            lodash.forEach(e.files, function(file) {
                vm.dlNotifications.push({
                    template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.uploading', 'Uploading...'), file),
                    id: file.uid,
                });
                $scope.$apply();
            });
            if (lodash.has(vm.options, 'upload.attr.sender_name')) {
                e.sender.name = lodash.get(vm.options, 'upload.attr.sender_name', 'file_element');
            }
        }

        function handleUploadSuccess(e) {
            vm.folderId = lodash.get(e, 'response.data.folder_id', null);
            if (lodash.has(e, 'response.data.edit_model')) {
                vm.selectData.selected.push(lodash.get(e, 'response.data.edit_model', {}));
            }
            vm.dataSource.page(1);
            // vm.dataSource.read();
            lodash.forEach(e.files, function(file) {
                removeDlNotificationByUid(file.uid);
                $scope.$apply();
                addNotificationWithTimeout({
                    template: $filter('templateReplacement')(lodash.get(vm.options, 'labels.uploaded', 'Uploaded...'), file),
                    id: file.uid,
                }, true);
            });
        }

        function handleUploadProgress(e) {
            console.log('upload in progress', e.percentComplete);
        }

        function handleUploadError(e) {
            var response = JSON.parse(e.XMLHttpRequest.response);

            lodash.forEach(e.files, function(file) {
                removeDlNotificationByUid(file.uid);
                $scope.$apply();
                var responseMsg = '';
                if (lodash.has(response, 'rules.file_element')) {
	                  responseMsg = response.rules.file_element.join(', ');
                }

                addNotificationWithTimeout({
                    template: responseMsg,
                    id: file.uid,
                }, true);
            });
        }

        function handleUploadComplete() {

        }


        function toggleSelect(dataItem) {
            // if dataItem.type === 'folder'
            // do something.
            if (dataItem.item_type === 'folder') {
                // vm.folderId = dataItem.id;
                changeFolder(dataItem.id);
                // vm.dataSource.read();
            } else {
                // else
                const index = lodash.findIndex(vm.selectData.selected, {select_id: dataItem.select_id});
                if (index >= 0) {
                    vm.selectData.selected.splice(index, 1);
                } else {
                    vm.selectData.selected.push(lodash.get(dataItem, 'edit_model', {}));
                }
            }
        }

        function isItemSelected(dataItem) {
            return !(lodash.find(vm.selectData.selected, { select_id: dataItem.edit_model.select_id}) === undefined);
        }

        function dismiss() {
            if (lodash.has(vm.options, 'trigger.close')) {
                $scope.$emit(vm.options.trigger.close);
            }
            if (!!vm.close) {
                vm.close(false);
            }
        }

        function removeDlNotification(notification) {
            const index = lodash.findIndex(vm.dlNotifications, notification);
            vm.dlNotifications.splice(index, 1);
        }

        function removeDlNotificationByUid(uid) {
            const index = lodash.findIndex(vm.dlNotifications, function(noti) {
               return noti.id === uid;
            });
            vm.dlNotifications.splice(index, 1);
        }

        function addNotificationWithTimeout(notification, scopeApply) {
            vm.dlNotifications.push(notification);
            if (scopeApply) { $scope.$apply(); }
            $timeout(function() {
                removeDlNotification(notification);
            }, 3000);
        }

        function changeFolder(id) {
            vm.folderId = id;
            vm.selectData.selected = [];
            vm.dataSource.page(1);
            // vm.dataSource.read();
        }
    }
})();